module.exports = __webpack_public_path__ + "img/pro-xtIcon3.9cccb4d4.png";